// Third-party imports
import $ from 'jquery';

import * as currency from '../util/currency.js';

export function initialize(global) {
    let calculatedTotals = calculateTotals();
    setTotals('once', calculatedTotals);
    setTotals('monthly', calculatedTotals);
    setTotals('total', calculatedTotals);
    customizeCardStepInitializer(global);
}

function setTotals(type, totals) {
    let price = priceStringToFloat(totals[type]);
    if (price) {
        $('.orderForm-value--' + type)
            .closest('.orderForm-item')
            .show();
        $('.orderForm-value--' + type).html(totals[type]);
    } else {
        $('.orderForm-value--' + type)
            .closest('.orderForm-item')
            .hide();
    }
}

// global is expected to be the window object when run in a browser context
function customizeCardStepInitializer(global) {
    let showCustomizeCardStep = global.document.querySelector(
        '.js-showCustomizeCardStep'
    );

    toggleCheckoutButtonsClasses(showCustomizeCardStep);
    toggleBasketSteps(showCustomizeCardStep);
}

function toggleCheckoutButtonsClasses(showCustomizeCardStep) {
    let regularButton = $('.js-regularCheckoutButton');
    let giftCardButton = $('.js-giftCardsCheckoutButton');
    // This is TRUE if an ODN product has a invalid value. We don't show
    // the card customization button as the continue to checkout button
    // remains visible but disabled
    let cartError = giftCardButton.data('cartError');

    if (showCustomizeCardStep && cartError !== true) {
        regularButton.addClass('u-hide');
        giftCardButton.removeClass('u-hide');
    } else {
        regularButton.removeClass('u-hide');
        giftCardButton.addClass('u-hide');
    }
}

function toggleBasketSteps(showCustomizeCardStep) {
    let giftCardStep = $('ol.basketSteps li:nth-child(2)');

    if (showCustomizeCardStep) {
        giftCardStep.removeClass('u-hide');
    } else {
        giftCardStep.addClass('u-hide');
    }
}

export function priceStringToFloat(price) {
    price = price.replace('$', '');
    price = price.replace(',', '.');
    return parseFloat(price);
}

function calculateTotals() {
    let onceTotal = 0;
    let monthlyTotal = 0;
    $('.basket-items .basketCard').each(function(index, item) {
        let frequency = $(item).data('frequency');
        if (frequency === 'SG' || frequency === '') {
            onceTotal += getPrice(item);
        } else {
            monthlyTotal += getPrice(item);
        }
    });
    let ret = {
        once: currency.format(onceTotal, true),
        monthly: currency.format(monthlyTotal, true),
        total: currency.format(onceTotal + monthlyTotal, true),
    };
    return ret;
}

function getPrice(item) {
    let price = $(item)
        .find('.basketCard-total')
        .text();
    price = parseInt(price.replace(/\D/g, ''), 10);
    return price;
}
